var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['loading', { large: !_vm.inline, 'd-inline': _vm.inline, 'text-primary': _vm.color === 'primary' }]},[_c('FontAwesomeIcon',{attrs:{"icon":"circle-notch","spin":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }